import { currentLocale, type Locale } from '@/i18n/locale'

const REGISTRY: { name: string; versions: Record<Locale, object> }[] = []

/**
 * Une table de libellés en deux langues, qui se lit comme avant :
 * `TASK_STATUS_LABELS[status]` rend la version de la langue de l'écran **au
 * moment de la lecture**. Les appels existants — nombreux, dans l'équipe comme
 * au portail — ne changent pas ; l'équipe, toujours en français, lit la même
 * chose qu'avant. Le typage impose les mêmes clés aux deux versions, et le
 * contrôle de parité les relit (`localizedTables`).
 */
export function localized<T extends object>(name: string, versions: Record<Locale, T>): T {
  REGISTRY.push({ name, versions })
  const pick = () => versions[currentLocale()]
  return new Proxy(versions.fr, {
    get: (_target, key) => Reflect.get(pick(), key) as unknown,
    has: (_target, key) => Reflect.has(pick(), key),
    ownKeys: () => Reflect.ownKeys(pick()),
    getOwnPropertyDescriptor: (_target, key) => Reflect.getOwnPropertyDescriptor(pick(), key),
  })
}

/** Les tables déclarées, pour le contrôle de parité. */
export function localizedTables(): readonly { name: string; versions: Record<Locale, object> }[] {
  return REGISTRY
}
